/**
 * Saca el código OTP de lo que el usuario tenga en el portapapeles.
 *
 * Por qué existe: en Android NINGÚN teclado sugiere el código que llegó por
 * EMAIL — el autofill de códigos del sistema es sólo para SMS (WebOTP), y el
 * de iOS (Mail → `autocomplete="one-time-code"`) no tiene equivalente ahí. El
 * camino corto que sí existe es copiar del mail y pegar de un toque, y lo que
 * se copia rara vez es el código pelado: puede ser el asunto entero
 * ("483920 es tu código para entrar") o un código viejo agrupado ("483 920").
 *
 * Sacamos espacios y guiones y buscamos una corrida de EXACTAMENTE 6 dígitos.
 * El borde (`^`/`$`/no-dígito) no es cosmético: sin él, un "Pedido 1234 5678"
 * en el portapapeles se leería como "123456" y quemaría uno de los 5 intentos
 * que el backend permite antes de invalidar el código.
 */
export function extractOtp(raw: string): string | null {
  return raw.replace(/[\s-]/g, '').match(/(^|\D)(\d{6})(\D|$)/)?.[2] ?? null;
}
